import { render, staticRenderFns } from "./DashboardsOverview.vue?vue&type=template&id=1b796e8f"
import script from "./DashboardsOverview.vue?vue&type=script&lang=js"
export * from "./DashboardsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports